import React from 'react';

import { Badge } from '@amzn/awsui-components-react-v3';

import { AsyncState, Serial } from '../../store/types';

export interface SerialStatusProps {
  processing: boolean;
  serial: Serial;
  containerId: string;
}

export const SerialStatus = ({ processing, serial, containerId }: SerialStatusProps) => {
  const tokenState = processing ? serial.receiveStatus?.receiveStatusType : serial?.state;

  const getColor = () => {
    if (tokenState === AsyncState.CREATED || tokenState === AsyncState.WARNING) {
      return 'blue';
    }
    if (tokenState === AsyncState.IN_PROGRESS) {
      return 'grey';
    }
    if (tokenState === AsyncState.ERROR) {
      return 'red';
    }

    if (tokenState === AsyncState.OK) {
      return 'green';
    }
  };

  const color = getColor();

  return (
    <div aria-label={`serial-state-${color}`}>
      <Badge color={color}>{tokenState}</Badge>
    </div>
  );
};
